import Image from '@components/ui/image'
import { urlFor } from '@lib/sanity/url-for'
import { motion, MotionValue, useTransform } from 'framer-motion'
import React, { FC } from 'react'
import { SanityAsset } from 'sanity-codegen'
import * as styles from './styles'

type SectionImageProps = {
  scrollY: MotionValue<number>
  start: number
  windowHeight: number
  multiplier: number
  imageSourceMobile: SanityAsset
  imageSourceDesktop: SanityAsset
}

export const SectionImage: FC<SectionImageProps> = ({
  scrollY,
  start,
  windowHeight,
  multiplier,
  imageSourceMobile,
  imageSourceDesktop,
}) => {
  const startingPoint = start + multiplier * windowHeight
  const endPoint = startingPoint + windowHeight * 0.8
  const clipPath = useTransform(
    scrollY,
    [startingPoint, endPoint],
    ['polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)', 'polygon(0 0%, 100% 0%, 100% 100%, 0% 100%)']
  )

  return (
    <div className={styles.image}>
      <motion.div
        className={styles.clip}
        style={{
          clipPath: multiplier > 0 ? clipPath : 'polygon(0 0%, 100% 0%, 100% 100%, 0% 100%)',
        }}
      >
        <Image
          alt=""
          position="absolute"
          placeholderSrc={urlFor(imageSourceMobile).width(20).url()}
          sources={[
            urlFor(imageSourceMobile).width(620).url(),
            urlFor(imageSourceMobile).width(620).url(),
            urlFor(imageSourceMobile).width(620).url(),
            urlFor(imageSourceDesktop).width(960).url(),
          ]}
          height={['100%']}
          width={['100%']}
          objectPosition="center"
        />
      </motion.div>
    </div>
  )
}
